import posthog from 'posthog-js';
import { logout } from '@/app/actions/auth';
import { callAction } from '@/lib/call-action';

/**
 * Signing out, everywhere — the whole act, not just the cookie.
 *
 * Four places used to do this by hand and two of them forgot `posthog.reset()`,
 * so leaving from the dashboard kept the analytics identity alive: the next
 * person to use that browser was recorded as the one who left. Identity is part
 * of being signed in, so it is dropped here rather than remembered at four call
 * sites.
 *
 * The reload is deliberate and full (`assign`, not a router push): the session
 * cookie is read on the server for every page, and only a fresh document
 * guarantees nothing rendered for the previous user survives in memory.
 *
 * `to` is where they land. Default home; a public page passes its own URL,
 * because a storefront reads perfectly well signed out and throwing a visitor
 * off the page they were reading is a punishment for leaving.
 */
export async function signOut(to = '/'): Promise<void> {
  posthog.reset();
  await callAction(logout);
  window.location.assign(to);
}
